











import { Component, Vue } from 'vue-property-decorator';
import notificationsStore from '@/project/shared/notifications/notifications.service';

@Component
export default class NotificationBanner extends Vue {
    private get notification() {
        return notificationsStore.notification;
    }

    private hideNotification() {
        notificationsStore.hideNotification();
    }
}
